import getIdFromIdIri from '../../shared/parsers/getIdFromIdIri';
import { findItemByIdIriFromArray } from '../../shared/utils/arrayTools';
import { usersAsCollaboratorsParser } from '../users/usersParser';

function folderParser(data: any, users: IIdIri[], authUserIdIri: string) {
  const ownerIdIri = data.owner['@id'] ? data.owner['@id'] : data.owner;
  const owner = findItemByIdIriFromArray(ownerIdIri, users) as IUser;

  const folder: IFolder = {
    idIri: data['@id'],
    id: getIdFromIdIri(data['@id']),
    name: data.name,
    collaborators: usersAsCollaboratorsParser(data.collaborators, authUserIdIri),
    isDefault: data.is_default,
    createdAt: data.created_at ?? null,
    updatedAt: data.updated_at ?? null,
    owner: { ...owner },
    totalAdStudies: data.total_ad_studies,
    totalNewAdStudies: data.total_new_ad_studies,
    hasUpdates: Boolean(data.total_new_ad_studies),
    totalCollaborators: data.total_collaborators,
  };

  return folder;
}
function foldersParser(datas: any[], users: IIdIri[], authUserIdIri: string) {
  try {
    const parsed = datas.map((m) => folderParser(m, users, authUserIdIri));

    return parsed;
  } catch (error: any) {
    throw new Error(error.message);
  }
}

export { folderParser, foldersParser };
